module.exports = __webpack_public_path__ + "img/featured-star.48ed98b8.svg";